const o = "_coloredCellRoot_p9vfp_1", e = "_numeric_p9vfp_13", l = {
  coloredCellRoot: o,
  numeric: e
};
export {
  o as coloredCellRoot,
  l as default,
  e as numeric
};
//# sourceMappingURL=index.es5642.js.map
